import React, { useState, useEffect } from 'react';
import PostThin from './PostThin';
import type { Post } from '@/Data/Social';
import './styles/FeedGroup.scss';
import { useUsers } from '@/Recoil/User';
import { FastAvatar } from '../FastAvatar';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: { "Write a post on": "Write a post on" },
    id: { "Write a post on": "Tulis postingan tentang" },
    ko: { "Write a post on": "글 작성하기:" },
    vn: { "Write a post on": "Viết bài về" },
};

interface FeedGroupProps {
    category: [string, string];
    contents: Post[];
}

const FeedGroup: React.FC<FeedGroupProps> = ({ category, contents }) => {
    const {profiles} = useUsers();
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    const [categoryName, categoryTranslation] = category;
    const groupRef = React.useRef<HTMLDivElement>(null);

    const userProfiles = contents.map(post => profiles[post.addressid]);

    return (
        <div className="FeedGroup" ref={groupRef}>
            <div className="Header">
                <div className="VerticalLine" />
                <div className="Category">
                    <div className="Dot" />
                    <span className="Name">{categoryName}</span>
                    <span className="Translation">{categoryTranslation}</span>
                    
                    <span className='Translation'>{`(${contents.length})`}</span>
                </div>
                <div className="Count">
                    <div className="Faces">
                        {userProfiles.slice(0, 3).map((profile, index) => (
                            <FastAvatar
                                key={index}
                                userid={profile?.addressid}
                                size={25}
                                uri={profile?.image}
                                className="Face"
                                style={{
                                    borderRadius: '50%',
                                    marginLeft: -6,
                                    border: '2px solid white',
                                }}
                            />
                        ))}
                        {userProfiles.length > 3 && (
                            <div className="MoreFaces">+{userProfiles.length - 3}</div>
                        )}
                    </div>
                </div>
            </div>
            <div className="Contents">
                {contents.map((post, index) => (
                    <PostThin
                        key={post.postid}
                        post={post}
                        isLast={index === contents.length - 1}
                        disableNavigation={post.addressid === 'mr_mate'}
                    />
                ))}
            </div>
            <div className="WriteNewPostButton">
                <button className="Button" onClick={() => {
                    // TODO: Replace with actual app install link
                    window.open('https://koreanmate.onelink.me/Tkco/y94asact', '_blank');
                }}>
                    {`${t("Write a post on")} ${category.join(', ')}`}
                </button>
            </div>
        </div>
    );
};

export default FeedGroup;
